import reducer from "./reducer";
export { default as OnboardingProfiles } from "./components/index";
export { default as onboardingProfilesReducerName } from "./constants";
export default reducer;
